module.exports = __webpack_public_path__ + "img/bg_duoduop_des_2.03db971c.jpg";